import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './GuestWelcomeModal.css';

const GuestWelcomeModal = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="guest-modal-overlay" onClick={onClose}>
            <div className="guest-modal-container" onClick={e => e.stopPropagation()}>
                <div className="guest-modal-header">
                    <div className="nova-logo">NovaInk</div>
                    <button className="guest-modal-close" onClick={onClose}>&times;</button>
                </div>

                <div className="guest-modal-body">
                    <div className="welcome-icon">✨</div>
                    <h2>{t('welcome_modal_title') || 'Bem-vindo ao NovaInk'}</h2>
                    <p>{t('welcome_modal_desc') || 'Explore o portfólio dos melhores tatuadores. Para solicitar artes, orçamentos e interagir com o sistema, você precisa estar conectado.'}</p>
                </div>

                <div className="guest-modal-footer">
                    <button
                        className="guest-modal-btn btn-primary"
                        onClick={() => navigate('/login')}
                    >
                        {t('login_and_explore') || 'Entrar e Explorar'}
                    </button>
                    <button
                        className="guest-modal-btn btn-secondary"
                        onClick={() => navigate('/register')}
                    >
                        {t('i_want_to_join') || 'Quero me cadastrar'}
                    </button>
                    <button
                        className="guest-modal-btn btn-text"
                        onClick={onClose}
                    >
                        {t('just_browsing') || 'Apenas navegando'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GuestWelcomeModal;
